// src/components/crm/NoteInclusionPicker.js
// r1-3f-picker-ui-8c1a4f7d
// Presentational tick-list for choosing which customer-facing notes ride along
// on generated invoices. Everything is ticked by default; the caller owns the
// exclusion Sets and toggle handlers. Reused by the batch flow
// (JobManagementView) and the single flow (InvoiceFormModal).

import React from 'react';
import { Image } from 'lucide-react';

// legnotes9-6b4e8d12 — SEAM 9. The `excludedLegacyJobIds` and `onToggleLegacy`
// props are gone with the "Older job notes from this job" row they drove. That
// row was gated on `g.hasLegacy`, which Seam 8 made permanently false.
const NoteInclusionPicker = ({
  groups,
  excludedNoteIds,
  onToggleNote,
  showJobLabels = true,
}) => {
  if (!groups || groups.length === 0) return null;
  return (
    <div className="space-y-4 max-h-72 overflow-y-auto">
      {groups.map((g) => (
        <div key={g.jobId} className="border border-gray-200 rounded-lg p-3">
          {showJobLabels && (
            <p className="text-sm font-semibold text-gray-800 mb-2 truncate">{g.jobLabel}</p>
          )}
          <div className="space-y-2">
            {g.notes.map((n) => (
              <label key={n.id} className="flex items-start gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={!excludedNoteIds.has(n.id)}
                  onChange={() => onToggleNote(n.id)}
                  className="w-4 h-4 mt-0.5 rounded border-gray-300 text-purple-600 cursor-pointer"
                />
                <span className="text-sm text-gray-700 flex-1 min-w-0">
                  <span className="block truncate">{n.preview}</span>
                  {n.photoCount > 0 && (
                    <span className="inline-flex items-center gap-1 text-xs text-gray-400 mt-0.5">
                      <Image size={12} /> {n.photoCount} photo{n.photoCount !== 1 ? 's' : ''}
                    </span>
                  )}
                </span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NoteInclusionPicker;
